// Sincronizzazione filtri di ricerca <-> query string dell'URL, condivisa da
// tutte le pagine con filtri (Macchine, Storico, Pagamenti, Incassi, Calendario).
// Nessuna dipendenza da Composition API/mixin: due funzioni pure richiamate da
// mounted()/methods, coerente con lo stile Options API del resto del progetto.
// Funziona anche attraverso il flusso /embed-login (redirect con query annidata)
// e il fallback di login manuale: entrambi passano da $route.query invariato.

const CONVERTITORI = {
    number: v => Number(v),
    string: v => v,
    boolean: () => true, // presenza del param = true; l'assenza lascia il default del componente (false)
    "number[]": v => v.split(",").map(Number).filter(n => !Number.isNaN(n)),
};

// Legge da route.query solo le chiavi elencate in `definizioni` (mappa chiave -> tipo).
// Se una chiave non è presente nell'URL, non viene inclusa nel risultato: il default
// del componente resta intatto (utile per non sovrascrivere con `undefined`).
export function leggiFiltriDaQuery(route, definizioni) {
    const risultato = {};
    for (const [chiave, tipo] of Object.entries(definizioni)) {
        const raw = route.query[chiave];
        if (raw === undefined) continue;
        risultato[chiave] = CONVERTITORI[tipo](raw);
    }
    return risultato;
}

// Aggiorna l'URL corrente con i valori di `filtri`, senza ricaricare la pagina e
// senza sporcare la cronologia (router.replace). Preserva ogni altro query param
// già presente (es. "embed"). Le chiavi vuote/false/array-vuoto vengono rimosse
// dall'URL invece di scriverle come stringa vuota.
export function scriviFiltriSuQuery(router, route, filtri) {
    const query = { ...route.query };
    for (const [chiave, valore] of Object.entries(filtri)) {
        const vuoto = valore === null || valore === undefined || valore === "" || valore === false ||
            (Array.isArray(valore) && valore.length === 0);
        if (vuoto) delete query[chiave];
        else query[chiave] = Array.isArray(valore) ? valore.join(",") : String(valore);
    }
    router.replace({ query }).catch(() => {});
}
